import { createRouter, createWebHashHistory } from "vue-router";

export default async ({ store }) => {
  let routes = [

    //fund_applications routes
    {
      path: "/fund_applications",
      alias: "/fund_applications/:fieldName/:fieldValue",
      name: "fund_applicationslist",
      component: () => import("./pages/fund_applications/list.vue"),
      props: true,
    },

    {
      path: "/fund_applications/view/:id",
      name: "fund_applicationsview",
      component: () => import("./pages/fund_applications/view.vue"),
      props: true,
    },

    //third_party_agencies routes
    {
      path: "/third_party_agencies/view/:id",
      name: "third_party_agenciesview",
      component: () => import("./pages/third_party_agencies/view.vue"),
      props: true,
    },

    //third_party_agencies_accounts routes
    {
      path: "/third_party_agencies_accounts",
      alias: "/third_party_agencies_accounts/:fieldName/:fieldValue",
      name: "third_party_agencies_accountslist",
      component: () => import("./pages/third_party_agencies_accounts/list.vue"),
      props: true,
    },

    {
      path: "/third_party_agencies_accounts/view/:id",
      name: "third_party_agencies_accountsview",
      component: () => import("./pages/third_party_agencies_accounts/view.vue"),
      props: true,
    },

    {
      path: "/account/edit",
      name: "third_party_agencies_accountsaccountedit",
      component: () => import("./pages/account/accountedit.vue"),
      props: true,
    },

    {
      path: "/account",
      name: "third_party_agencies_accountsaccountview",
      component: () => import("./pages/account/accountview.vue"),
      props: true,
    },

    {
      path: "/third_party_agencies_accounts/add",
      name: "third_party_agencies_accountsadd",
      component: () => import("./pages/third_party_agencies_accounts/add.vue"),
      props: true,
    },

    {
      path: "/third_party_agencies_accounts/edit/:id",
      name: "third_party_agencies_accountsedit",
      component: () => import("./pages/third_party_agencies_accounts/edit.vue"),
      props: true,
    },

    //third_party_agencies_grants routes
    {
      path: "/third_party_agencies_grants",
      alias: "/third_party_agencies_grants/:fieldName/:fieldValue",
      name: "third_party_agencies_grantslist",
      component: () => import("./pages/third_party_agencies_grants/list.vue"),
      props: true,
    },

    {
      path: "/third_party_agencies_grants/view/:id",
      name: "third_party_agencies_grantsview",
      component: () => import("./pages/third_party_agencies_grants/view.vue"),
      props: true,
    },

    {
      path: "/third_party_agencies_grants/add",
      name: "third_party_agencies_grantsadd",
      component: () => import("./pages/third_party_agencies_grants/add.vue"),
      props: true,
    },

    {
      path: "/third_party_agencies_grants/edit/:id",
      name: "third_party_agencies_grantsedit",
      component: () => import("./pages/third_party_agencies_grants/edit.vue"),
      props: true,
    },

    // Info Pages
    {
      path: "/info/help",
      name: "helppage",
      component: () => import("./pages/info/help.vue"),
      props: true,
    },


    //Otp verify code routes
    {
      path: "/index/verifyotp",
      name: "verifyotp",
      component: () => import("./pages/index/verifyotp.vue"),
      props: true,
    },

    //Password reset routes
    {
      path: "/index/forgotpassword",
      name: "forgotpassword",
      component: () => import("./pages/index/forgotpassword.vue"),
      props: true,
    },
    {
      path: "/index/resetpassword",
      name: "resetpassword",
      component: () => import("./pages/index/resetpassword.vue"),
      props: true,
    },
    {
      path: "/index/resetpassword_completed",
      name: "resetpassword_completed",
      component: () => import("./pages/index/resetpassword_completed.vue"),
      props: true,
    },

    //Email verify routes
    {
      path: "/index/verifyemail",
      name: "verifyemail",
      component: () => import("./pages/index/verifyemail.vue"),
      props: true,
    },
    {
      path: "/index/emailverified",
      name: "emailverified",
      component: () => import("./pages/index/emailverified.vue"),
      props: true,
    },

    {
      path: "/index/accountcreated",
      name: "accountcreated",
      component: () => import("./pages/index/accountcreated.vue"),
      props: true,
    },
    {
      path: "/index/accountinactive",
      name: "accountinactive",
      component: () => import("./pages/index/accountinactive.vue"),
      props: true,
    },
    {
      path: "/index/accountpending",
      name: "accountpending",
      component: () => import("./pages/index/accountpending.vue"),
      props: true,
    },
    {
      path: "/index/accountblocked",
      name: "accountblocked",
      component: () => import("./pages/index/accountblocked.vue"),
      props: true,
    },

    {
      path: "/error/forbidden",
      name: "forbidden",
      component: () => import("./pages/errors/forbidden.vue"),
      props: true,
    },
    {
      path: "/error/notfound",
      name: "notfound",
      component: () => import("./pages/errors/pagenotfound.vue"),
      props: true,
    },
    {
      path: "/:catchAll(.*)",
      component: () => import("./pages/errors/pagenotfound.vue"),
    },
  ];

  let loginToken = store.getters["auth/getLoginToken"];
  if (loginToken) {
    //Token is available, user might still be logged in
    try {
      //fetch user data for the first time and saves in the vuex store
      await store.dispatch("auth/getUserData");
    } catch (e) {
      store.dispatch("auth/logout"); //token must have expired
    }
  }

  let user = store.state.auth.user;
  if (user) {
    routes.push({
      path: "/",
      alias: "/home",
      name: "home",
      component: () => import(`./pages/home/home.vue`),
      props: true,
    });
  } else {
    routes.push({
      path: "/",
      alias: "/index",
      name: "index",
      component: () => import("./pages/index/index.vue"),
      props: true,
    });
  }

  const router = createRouter({
    history: createWebHashHistory(),
    routes,
  });

  router.beforeEach(function (to, from, next) {
    window.scrollTo(0, 0);
    next();
  });

  return router;
};
